var map = {
	"./act": 1371,
	"./act.ts": 1371,
	"./gmat": 1372,
	"./gmat.ts": 1372,
	"./gre": 1373,
	"./gre.ts": 1373,
	"./ielts": 1374,
	"./ielts.ts": 1374,
	"./ielts_general_training": 1375,
	"./ielts_general_training.ts": 1375,
	"./lsat": 1376,
	"./lsat.ts": 1376,
	"./mcat": 1377,
	"./mcat.ts": 1377,
	"./sat": 1378,
	"./sat.ts": 1378,
	"./toefl": 1379,
	"./toefl.ts": 1379
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2325;
module.exports = webpackAsyncContext;